export function SBDCenter({ children }: { readonly children: React.ReactNode }) {
  return (
    <div className="relative order-2 flex h-full w-full flex-row items-center overflow-hidden pt-18">
      {children}
    </div>
  );
}
